export enum AuthBroadcastMessageType {
  Up = 'Up',
  Logout = 'Logout'
}

export function createAuthBroadcastChannel() {
  return new BroadcastChannel('bc-app-auth')
}
